import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Reason } from 'src/features/points/types';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/points/reasons/';

interface DTO extends ListDTO {
    parkingId: string;
}

type QueryFnType = typeof queryFn;
export const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<Reason>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
export const useQueryHook = ({ config, ...params }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, params],
        queryFn: async () => await queryFn(params),
        ...config,
    });
};

export { RESOURCE as LIST_REASONS_RESOURCE, queryFn as listReasons, useQueryHook as useListReasons };
export type { DTO as ListReasonsDTO };
